import { Tag } from "../../models/tag";
import { TagCategory } from "../../models/tagCategory";

export const editTagCategory = async (
    tagCategory: TagCategory, 
    API_URL: string, 
    token: string, 
    employerId: string) => {
        const response = await fetch(
            `${API_URL}/employers/${employerId}/tag-categories/${tagCategory.id}`,
            {
                method: "PUT",
                headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    ...tagCategory,
                    tags: tagCategory.tags.map((tag: Tag) => {
                        return {
                        ...tag,
                        id: tag.id.includes("local") ? undefined : tag.id // Strips out the local IDs in request
                        };
                    })
                })
            }
        );
        if (!response.ok)
            throw new Error(
                "There was a problem updating this Tag Category. To delete a tag, it first must not be assigned to any users."
            );
}